import { H1, Text } from "atoms";
import { Head } from "features/misc";

function Apply() {
  return (
    <main>
      <Head title="Apply" />

      <H1>Apply</H1>
      <Text size="lg">
        <em>Coming Soon.</em>
      </Text>
    </main>
  );
}

export { Apply };
